/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

type ChevronIconProps = {
	testId?: string;
};

/**
 * The disclosure chevron from atlassian.com's own top nav, the one beside
 * "Products": an 11x6 stroked path with round caps and joins, at its natural
 * size.
 *
 * Inline rather than an `@atlaskit/icon` chevron so it is that exact artwork,
 * and not an `.svg` import because those resolve to a URL and load through
 * `<img>`, which cannot inherit `currentColor`. The stroke replaces
 * atlassian.com's hardcoded #101214, drawn for a light nav; here it has to
 * follow the label through hover and the current-page state.
 */
export const ChevronIcon = ({ testId = 'nav-chevron-icon' }: ChevronIconProps): JSX.Element => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="11"
		height="6"
		viewBox="0 0 11 6"
		fill="none"
		aria-hidden="true"
		focusable="false"
		data-testid={testId}
	>
		<path
			d="M9.19922 1.18176L5.19922 4.81813L1.19922 1.18176"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
